import { render, staticRenderFns } from "./RequisitionCrafts.vue?vue&type=template&id=05efd377&"
import script from "./RequisitionCrafts.vue?vue&type=script&lang=js&"
export * from "./RequisitionCrafts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports